export default {"src":"/_next/static/media/0x04068da6c83afcfa0e13ba15a6696662335d5b75.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};